import { MILESTONE_KEY, MILESTONE_STATUS } from "./constants";
import {
  getServiceCompletionConfirmed,
  isFollowUpMilestoneKey,
  normalizeRemanufacturingMilestonesList,
  pruneFollowUpMilestonesAfterTerminal,
} from "./remanufacturingMilestones";

/**
 * @param {import("./remanufacturingMilestones").ServiceMilestone[]} milestones
 * @returns {import("./remanufacturingMilestones").ServiceMilestone|undefined}
 */
export function getTerminalServiceMilestone(milestones) {
  const chain = milestones
    .filter(
      (milestone) =>
        milestone.key === MILESTONE_KEY.M3 || isFollowUpMilestoneKey(milestone.key)
    )
    .sort(
      (a, b) =>
        (a.sortOrder ?? Number.MAX_SAFE_INTEGER) -
        (b.sortOrder ?? Number.MAX_SAFE_INTEGER)
    );

  return chain.find((milestone) => getServiceCompletionConfirmed(milestone));
}

/**
 * True when every milestone is completed and the terminal milestone confirms
 * service completion (M3 or the last follow-up with serviceCompletionConfirmed).
 *
 * @param {unknown[]|null|undefined} milestones
 */
export function isRemanufacturingServiceComplete(milestones) {
  const normalized = normalizeRemanufacturingMilestonesList(
    Array.isArray(milestones) ? milestones : []
  );
  const pruned = pruneFollowUpMilestonesAfterTerminal(normalized);
  const terminal = getTerminalServiceMilestone(pruned);

  if (!terminal || terminal.status !== MILESTONE_STATUS.COMPLETED) {
    return false;
  }

  return pruned.every(
    (milestone) => milestone.status === MILESTONE_STATUS.COMPLETED
  );
}
